import { DynamicTable } from '@Components/General/DynamicTable';
import { EmailField } from '@Components/General/DynamicTable/Cells';
import useSidePan from '@hooks/useSidePan';
import { Card, CardContent, CardHeader } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { emailRecipientsQueryOptions } from '@utils/queryOptions';
import { useTranslation } from 'react-i18next';

const EmailRecipients = () => {
    const { t } = useTranslation();
    const { emailId } = useParams({});
    const { data } = useSuspenseQuery(emailRecipientsQueryOptions(emailId));

    const openSidePan = useSidePan();

    return (
        <Card sx={{ flex: 1 }}>
            <CardHeader
                title={t('Recipients')}
                // avatar={<GroupsRounded />}
            />
            <CardContent>
                <DynamicTable
                    columns={[
                        { name: t('Name'), field: 'display_name' },
                        {
                            name: t('Email'),
                            field: 'email_addresses',
                            Component: EmailField,
                        },
                        {
                            name: t('Status'),
                            field: 'event.event_type',
                            renderField: row =>
                                t('emailEvents.' + row.event?.event_type),
                        },
                        { name: t('Note'), field: 'event.note' },
                    ]}
                    rows={data}
                    rowProps={row =>
                        row?.contact_id && {
                            onClick: () =>
                                openSidePan({ contactId: row?.contact_id }),
                        }
                    }
                />
            </CardContent>
        </Card>
    );
};

export default EmailRecipients;
